module.exports = __webpack_public_path__ + "img/gourmandises.7c7638db.png";